import React from "react";
import FlowContainer from "../../components/FlowContainer";
import { brandclub_colors } from "@brandclub/common-ui";
import {
  FlowSolidButton,
  FlowSolidButtonGrey,
} from "../../components/FlowButtons";
import ReviewSelectPill from "../components/ReviewSelectPill";
import Loading from "../../../../../Loading";
import ProductHeader from "../components/ProductHeader";
import {
  ReviewQuestionContainer,
  ReviewInfo,
  ReviewSection,
  ReviewTitle,
  ReviewSubtitle,
  ReviewSelections,
  ReviewAddComments,
  ReviewLabel,
  TextAreaInputBox,
  ReviewTextInputWrapper,
} from "../components/ReviewStyledComponents";
import { Box } from "@mui/material";
import { FlowActionButtonsGroup } from "../../components/FlowStyledComponents";

type ProPageProps = {
  product: any;
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>;
  selectedOptions: string[];
  options: string[];
  moveBack: () => void;
  moveNext: () => void;
  feedback: string;
  setFeedback: React.Dispatch<React.SetStateAction<string>>;
};

const Pros = ({
  product,
  options,
  selectedOptions,
  setSelectedOptions,
  moveBack,
  moveNext,
  feedback,
  setFeedback,
}: ProPageProps) => {
  const handleSelect = (option: string) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((o) => o !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const disabledNext = selectedOptions.length === 0;
  return (
    <FlowContainer style={{ background: brandclub_colors.white }}>
      <ReviewQuestionContainer>
        <ReviewInfo>
          <ReviewSection>
            <ProductHeader product={product} />
          </ReviewSection>
          <ReviewSection
            sx={{
              flex: 1,
            }}
          >
            <ReviewTitle>What features did you like most?</ReviewTitle>
            <ReviewSubtitle>Select all that apply</ReviewSubtitle>
            <ReviewSelections>
              {options?.length ? (
                options.map((option) => {
                  const selected = selectedOptions?.includes(option);
                  return (
                    <ReviewSelectPill
                      selected={selected}
                      text={option}
                      onClick={() => {
                        handleSelect(option);
                      }}
                    />
                  );
                })
              ) : (
                <Box sx={{ width: "100%" }}>
                  <Loading dot />
                </Box>
              )}
            </ReviewSelections>
            <ReviewAddComments>
              <ReviewLabel htmlFor="feedback">Add comments</ReviewLabel>
              <ReviewTextInputWrapper>
                <TextAreaInputBox
                  id="feedback"
                  sx={{ maxHeight: "284px" }}
                  value={feedback}
                  placeholder="Enter description (optional)"
                  onChange={(e) => setFeedback(e.target.value)}
                ></TextAreaInputBox>
              </ReviewTextInputWrapper>
            </ReviewAddComments>
          </ReviewSection>
        </ReviewInfo>
        <FlowActionButtonsGroup>
          <FlowSolidButtonGrey onClick={moveBack}>Back</FlowSolidButtonGrey>
          <FlowSolidButton disabled={disabledNext} onClick={moveNext}>
            Next
          </FlowSolidButton>
        </FlowActionButtonsGroup>
      </ReviewQuestionContainer>
    </FlowContainer>
  );
};

export default Pros;
